module.exports = __webpack_public_path__ + "static/media/reader2.1796a9ae.jpg";